import { MemberEdit } from 'ui/components/buyer/patterns/MemberEdit/MemberEdit';

/**
 * 買い手メンバー編集
 */
export const BuyerMemberEdit: React.FC = () => {
    return <MemberEdit />;
};
